<template>
  <div class="all_body">
    <div class="dbjz">
      <div class="login_container">
        <div class="login_title">
          <div class="logo_mee"></div>
          <div class="login-title">柳州市智慧环保平台</div>
        </div>

        <div class="container">
          <div v-if="type == 'login'" class="login-box">
            <div class="username">
              <Input
                v-model="form.username"
                placeholder="用户名"
                @on-focus="onFocus('username')"
                @on-blur="onBlur('username')"
                @on-enter="toLogin"
              />
              <div class="rules">{{ rules.username }}</div>
            </div>

            <div class="password">
              <Input
                v-model="form.password"
                placeholder="密码"
                type="password"
                password
                @on-focus="onFocus('password')"
                @on-blur="onBlur('password')"
                @on-enter="toLogin"
              />
              <div class="rules">{{ rules.password }}</div>
            </div>

            <div v-if="error" class="error">{{ error }}</div>

            <Checkbox v-model="remember" class="remember-pwd">记住密码</Checkbox>

            <Button type="primary" class="login-btn" :loading="btnLoading" @click="toLogin">登录</Button>
          </div>
          <div v-if="type == 'login'" class="dataShow">
            <div class="dataShowMain">
              <div class="kqzl">
                <i-circle
                  :percent="data.newAQI"
                  dashboard
                  :stroke-width="8"
                  :trail-width="8"
                  :stroke-color="data.Color"
                >
                  <h1 v-if="!loading" style="margin-top: 8px">{{ data.AQI || "--" }}</h1>
                  <p v-if="data.Type && !loading" style="margin-top: 8px">{{ data.Type }}</p>
                </i-circle>
                <Tooltip
                  :content="data.Description"
                  :transfer="true"
                  :max-width="200"
                  placement="right-start"
                >
                  <div
                    class="jkts"
                    :style="{
                      backgroundColor: data.backgroundColor,
                      color: data.Color,
                    }"
                  >
                    <svg
                      :fill="data.Color"
                      t="1652753653491"
                      class="icon"
                      viewBox="0 0 1151 1024"
                      version="1.1"
                      p-id="5422"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M1051.768112 587.715272l-398.461012 403.900971a108.799184 108.799184 0 0 1-154.68684 0L100.095249 587.523274a345.597408 345.597408 0 0 1 0-486.396352A339.197456 339.197456 0 0 1 342.589431 0.00768a313.597648 313.597648 0 0 1 229.694277 99.647253 27.903791 27.903791 0 0 1 2.751979 2.751979A315.133636 315.133636 0 0 1 809.593928 0.00768a339.197456 339.197456 0 0 1 242.046185 100.863243 345.597408 345.597408 0 0 1 0 486.844349zM991.99256 160.774474a255.99808 255.99808 0 0 0-182.398632-76.03143 229.566278 229.566278 0 0 0-171.454714 73.599448l-29.119782 37.311721a42.431682 42.431682 0 0 1-32.447756 15.99988 41.34369 41.34369 0 0 1-32.575756-15.039888l-31.99976-38.399712a229.246281 229.246281 0 0 0-169.406729-73.471449A258.942058 258.942058 0 0 0 84.287368 344.325098 258.68606 258.68606 0 0 0 159.9988 527.747722l398.781009 404.220968a25.151811 25.151811 0 0 0 34.815739 0L991.99256 527.875721a260.670045 260.670045 0 0 0 0-367.101247z m5.119962 256.574076a31.423764 31.423764 0 0 1-45.951656 6.399952c-6.975948-5.823956-11.263916-31.99976-11.263915-31.99976a223.99832 223.99832 0 0 0-53.3116-101.887236 288.637835 288.637835 0 0 0-68.863484-51.199616 512.956153 512.956153 0 0 1-56.831574-20.543846 34.047745 34.047745 0 0 1-9.407929-23.487824 32.703755 32.703755 0 0 1 6.975948-20.287848 33.727747 33.727747 0 0 1 23.295825-12.799904 52.799604 52.799604 0 0 1 6.911948 0 220.862344 220.862344 0 0 1 26.6878 6.015955 335.869481 335.869481 0 0 1 109.439179 64.767515 281.213891 281.213891 0 0 1 69.247481 106.111204 193.150551 193.150551 0 0 1 8.063939 55.93558 75.583433 75.583433 0 0 1-4.927963 22.975828z"
                        p-id="5423"
                      />
                    </svg>
                    健康提示
                  </div>
                </Tooltip>
              </div>

              <div class="city">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    font-size: 16px;
                    font-weight: 700;
                  "
                >
                  <img
                    src="../../src/assets/images/position.png"
                    alt
                    style="
                      margin-right: 5px;
                      width: 24px;
                      height: 24px;
                      position: relative;
                      left: -4px;
                    "
                  />
                  <span>柳州市</span>
                </div>

                <div style="margin-bottom: 10px">更新时间 {{ data.Time }}</div>
                <div>首要污染物：{{ data.PrimaryPollutant }}</div>
              </div>
            </div>
          </div>
          <div v-if="type == 'QRcode'" class="QRcode">
            <div class="QRcode_title">APP下载</div>
            <div class="QRcode_container">
              <img src="../../public/static/img/zhhbapp1.png" alt />
            </div>

            <div class="QRcode_details">
              <Icon class="color" type="md-qr-scanner" size="26" />打开
              <span class="color">手机扫一扫</span>&nbsp;&nbsp;&nbsp;
              |&nbsp;&nbsp;
              <span>下载APP</span>
            </div>
          </div>
          <div class="newTime">{{ newTime }}</div>
          <div
            @click="switchover"
            class="icon-code"
            :title="iconCodeTitle"
            :class="[type == 'QRcode' ? 'app' : 'account']"
          ></div>
        </div>
      </div>
    </div>

    <div class="footer">
      <span class="footer-pc">Copyright © 柳州市智慧环保平台</span>
      <span class="footer-mobile">
        <span class="footer-text">柳州市生态环境局</span>
        <span class="footer-phone">0772-2615200</span>
      </span>
    </div>
    <!-- <p class="login_copyright">{{copyrightText}}</p> -->
  </div>
</template>
<script>
// const echarts = require("echarts");
const moment = require("moment");

function getErrorMessage(error) {
  if (error.response) {
    return error.response.data.msg;
  }

  if (error.message.indexOf("timeout") > -1) {
    return "连接超时，登录失败";
  }

  return error.message;
}

export default {
  data() {
    return {
      title: " ",
      cright: " ",
      copyrightText: "广州市云景信息科技有限公司提供技术支持",
      newTime: "",
      data: {},
      loading: false,
      rules: {
        username: "",
        password: ""
      },
      form: {
        username: "",
        password: "",
        remember: false,
        captcha: ""
      },
      error: "",
      btnLoading: false,
      baseUrl: "",
      type: "login", // login, QRcode
      iconCodeTitle: "点击下载APP",
      remember: false
    };
  },

  async created() {
    await this.$curl.get("/api/public/core/checkNet", {
      method: "get",
      timeout: 2000
    });

    const url = location.href;
    const index = url.indexOf("loginPad");
    this.baseUrl = url.substring(0, index - 1);
  },

  mounted() {
    // 获取空气质量数据
    this.loadData();
    // 实时时间跳动 并在 离开时销毁
    let timer = setInterval(() => {
      this.timeRun();
    }, 1000);
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });
    this.getPwd();
  },
  methods: {
    // 切换
    switchover() {
      if (this.type == "QRcode") {
        this.type = "login";
        this.iconCodeTitle = "点击下载APP";
      } else {
        this.type = "QRcode";
        this.iconCodeTitle = "账号密码登录";
      }
    },

    check() {
      let { form, rules } = this;
      if (!form.username) this.rules.username = "请输入账号";
      if (!form.password) this.rules.password = "请输入密码";

      return Boolean(form.username) && Boolean(form.password);
    },
    onFocus(key) {
      this.rules[key] = "";
      this.error = "";
    },
    onBlur(key) {
      if (key == "username") {
        !Boolean(this.form.username) && (this.rules.username = "请输入账号");
      }
      if (key == "password") {
        !Boolean(this.form.password) && (this.rules.password = "请输入密码");
      }
    },

    getPwd() {
      let isRemember = localStorage.getItem("isRemember") || false;
      let form = {};
      let userInfo = localStorage.getItem("userInfoStr") || "";
      if (userInfo) {
        userInfo = decodeURIComponent(atob(userInfo));
        userInfo = JSON.parse(userInfo);
        form = userInfo;
      }

      if (isRemember === "true") this.remember = true;

      if (this.remember && form.password) {
        this.form = form;
      }
    },

    async toLogin() {
      if (this.btnLoading) return; //避免重复登录
      if (!this.check()) return; //验证账号密码
      let form = JSON.parse(JSON.stringify(this.form));

      //如果手机的话，获取手机的macid，传过去，防止手机端登录过期
      let getDeviceFn = async () => {
        return new Promise((resolve, reject) => {
          try {
            if (plus && plus.device) {
              plus.device.getInfo({
                success: function(e) {
                  console.log("getDeviceInfo success: " + JSON.stringify(e));
                  console.log("e.uuid=" + e.uuid);
                  resolve(e.uuid);
                },
                fail: function(e) {
                  console.error("getDeviceInfo failed: " + JSON.stringify(e));
                  reject("");
                }
              });
            } else {
              console.error("无plus");
              reject("");
            }
          } catch (eee) {
            console.error("获取设备信息错误！" + eee.stack);
            reject("");
          }
        });
      };
      let macid = "";
      try {
        macid = await getDeviceFn();
      } catch (eeee) {
        console.error("获取uuid失败！" + eeee.stack);
        macid = "";
      }
      if (macid && macid !== "") {
        form.macid = macid;
      }

      this.btnLoading = true;
      this.$curl
        .post("/api/public/core/login", form)
        .then(res => {
          this.btnLoading = false;
          this.onloginOk();

          const userInfoStr = JSON.stringify(this.form);
          const enUserInfoStr = btoa(encodeURIComponent(userInfoStr));

          if (this.remember) {
            localStorage.setItem("userInfoStr", enUserInfoStr);
            localStorage.setItem("isRemember", this.remember);
          } else {
            localStorage.removeItem("isRemember");
            localStorage.removeItem("userInfoStr");
          }
        })
        .catch(err => {
          console.log("err", getErrorMessage(err));
          this.btnLoading = false;
          this.error = getErrorMessage(err);
        });
    },

    onloginOk() {
      let url = "/index.html?fullscreen#/lzepb/modules/mh";
      if (window.screen.width <= 1200) url = "index.html";

      location.href = url;
    },

    loadData() {
      if (this.loading) return;
      this.loading = true;
      this.$curl
        .get("/api/public/zhhb/mh/loginController/getAirData", {})
        .then(res => {
          this.loading = false;
          if (res.data.code != 1 || !res.data.data) return;
          this.data = res.data.data;
          this.data.backgroundColor = this.colorRgb(this.data.Color, "0.13");
          this.data.Time = moment(this.data.Date).format("HH:mm");
          this.data.newAQI = this.data.AQI / 3;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 时间跳动
    timeRun() {
      let week = ["日", "一", "二", "三", "四", "五", "六"];
      this.newTime = moment().format(
        `YYYY年MM月DD日 星期${week[moment().format("d")]} HH:mm:ss`
      );
    },
    // 十六进制转RGB
    // str: 十六进制颜色
    // diaphaneity： 透明度
    colorRgb(str, diaphaneity = 1) {
      // 16进制颜色值的正则
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      if (!str) return;
      // 把颜色值变成小写
      var color = str.toLowerCase();
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          var colorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
          }
          color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        var colorChange = [];
        for (var i = 1; i < 7; i += 2) {
          colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
        }
        return `RGB(${colorChange.join(",")},${diaphaneity})`;
      } else {
        return color;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1000px) {
  .all_body {
    min-height: 100% !important;
    background: url("/static/custom/loginBgPhone.png") no-repeat center center;
    overflow-y: overlay !important;
  }
  .login_container {
    top: 16% !important;
    right: 0px !important;
    left: 0px !important;

    .login_title {
      min-width: 100% !important;

      .logo_mee {
        width: 10.666vmin !important; /* 40px */
        height: 10.666vmin !important;
      }

      .login-title {
        font-size: 6.4vmin !important; /* 24px */
        color: #1d679e !important;
      }
    }
    .container {
      width: calc(100% - 8%) !important;
      margin-top: 8vmin !important; /* 30px */
      border-radius: 2.666vmin !important; /* 10px */
      background: rgba(255, 255, 255, 0.3) !important;

      .login-box {
        padding: 8vmin 8vmin 10.666vmin 8vmin !important; /* 30px 40px */

        ::v-deep .ivu-input {
          font-size: 4.266vmin !important; /* 16px */
          height: 12.266vmin !important; /* 46px */
          border-bottom-width: 0.2666vmin !important; /* 1px */
        }

        .username {
          margin-bottom: 6.4vmin !important; /* 24px */
        }
        .username,
        .password {
          .rules {
            font-size: 3.733vmin !important; /* 14px */
          }
        }

        .login-btn {
          margin-top: 8.533vmin !important; /* 32px */
          height: 11.733vmin !important; /* 44px */
          font-size: 5.333vmin !important; /* 20px */
          border-radius: 6.4vmin !important; /* 24px */
        }
      }

      .dataShow,
      .newTime {
        display: none;
      }
    }
  }
  .footer {
    display: block !important;
    position: fixed;
    bottom: 15px;
    left: 0;
    right: 0;
    transform: none;
    color: #333;
    font-size: 12px;
    text-align: center;
    background: transparent;
    padding: 10px;
    border-radius: 0;
    z-index: 9999;

    .footer-pc {
      display: none;
    }

    .footer-mobile {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .footer-text {
      display: block;
      margin-bottom: 4px;
    }

    .footer-phone {
      display: block;
    }
  }
}
/* pad */
@media screen and (min-width: 1000px) and (max-width: 1260px) {
  .all_body {
    background: url("/static/custom/loginBg.jpg") no-repeat center center;
  }
}

/* pc */
@media screen and (min-width: 1260px) {
  .all_body {
    background: url("/static/custom/loginBg.jpg") no-repeat center center;
  }

  .login_container {
    .QRcode {
      width: 100%;
      // background: #FFF;
      text-align: center;
      padding: 24px;

      .QRcode_title {
        font-size: 24px;
        font-weight: bold;
        text-align: left;
        color: rgba(0, 54, 102, 0.8);
        border-bottom: rgba(0, 54, 102, 0.8) 4px solid;
        width: 100px;
        padding-bottom: 8px;
      }
      .QRcode_container {
        width: 60%;
        height: 60%;
        margin: 24px auto;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.9);
        padding: 32px;
      }
      img {
        width: 100%;
      }
      .QRcode_details {
        font-size: 18px;
      }
      .color {
        color: rgba(0, 54, 102, 1);
      }
    }

    .icon-code {
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      height: 82px;
      cursor: pointer;
    }
    .account {
      background: url(/static/img/code.png) no-repeat;
      background-size: contain;
    }
    .app {
      background: url(/static/img/code1.png) no-repeat 50%;
      background-size: 50%;
    }
  }
}
.all_body {
  width: 100%;
  height: 100%;
  min-height: 635px;
  position: relative;
  overflow: visible;
  // background: url("../../src/assets/images/loginBg.jpg") no-repeat center center;
  background-size: cover;
  // background-size: 100% 100%;

  .footer {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 16px;
    text-align: center;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
    padding: 8px 16px;
    border-radius: 4px;

    .footer-pc {
      display: block;
    }

    .footer-mobile {
      display: none;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
    }

    .footer-text {
      display: inline;
    }

    .footer-phone {
      display: inline;
    }
  }
}

@media (max-width: 768px) {
  .all_body {
    .footer {
      position: fixed;
      bottom: 15px;
      left: 0;
      right: 0;
      transform: none;
      color: #333;
      font-size: 12px;
      text-align: center;
      background: transparent;
      padding: 10px;
      border-radius: 0;

      .footer-pc {
        display: none;
      }

      .footer-mobile {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .footer-text {
        display: block;
        margin-bottom: 4px;
      }

      .footer-phone {
        display: block;
      }
    }
  }
}

.login_copyright {
  width: 100%;
  margin-bottom: 1.5%;
  text-align: center;

  color: #828282;
  font-size: 14px;

  position: absolute;
  bottom: 0;
}
.login_container {
  // width: 90%;
  position: absolute;
  top: 10%;
  right: 16%;
  // transform: translate(-50%, -50%);

  .login_title {
    width: 100%;
    min-width: 562px;
    display: flex;
    justify-content: center;
    align-items: center;

    .logo_mee {
      width: 60px;
      height: 60px;
      display: inline-block;
      margin-right: 10px;
      background: url("/static/custom/logo.png") no-repeat center center;
      background-size: 100%;
    }

    .login-title {
      font-family: douyuFont;
      font-size: 42px;
      position: relative;
      top: 5px;
      // color: #2A5B8F;
      color: #fff;
    }
  }
  .container {
    margin: 0 auto;
    width: 500px;
    // height: 488px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 18px;
    margin-top: 30px;
    overflow: hidden;
    position: relative;

    .login_box {
      height: 100%;
      width: 100%;
      padding: 32px;
    }

    .dataShow {
      margin-top: 10px;
      padding: 10px 95px 0;
      // background: #fff;
      font-size: 18px;
      border-top: 1px dashed rgba(46, 72, 161, 0.3);
      .city {
        display: flex;
        flex-direction: column;
        color: #232d42;
        font-size: 14px;
        svg {
          width: 18px;
          vertical-align: text-bottom;
        }
      }
      .dataShowMain {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        .kqzl {
          margin-bottom: 13px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .ivu-chart-circle {
            width: 105px !important;
            height: 100px !important;
          }
        }
        .jkts {
          width: 94px;
          height: 23px;
          line-height: 17px;
          border-radius: 16px;
          text-align: center;
          font-size: 14px;
          padding: 4px;
          cursor: default;
          svg {
            width: 14px;
            margin-right: 4px;
            vertical-align: text-bottom;
          }
        }
      }
    }

    .newTime {
      height: 44px;
      // background: rgba(34, 72, 133, 0.6);
      background: rgba(0, 54, 102, 0.6);
      color: #fff;
      line-height: 44px;
      text-align: center;
      border-top: 1px #dbdbdb dashed;
      font-size: 18px;
      border-radius: 0 0 4px 4px;
    }

    .login-box {
      padding: 40px 95px;

      ::v-deep .ivu-input {
        background: transparent;
        font-size: 16px;
        height: 46px;
        border: none;
        border-bottom: 1px dashed #515a6e;
        border-radius: unset;
      }

      ::v-deep .ivu-input::-webkit-input-placeholder {
        color: #515a6e;
      }

      ::v-deep .ivu-input:focus {
        box-shadow: unset;
      }

      .login-btn {
        margin-top: 32px;
        height: 54px;
        border: none;
        color: #fff;
        width: 100%;
        font-size: 20px;
        border-radius: 24px;
        // background: linear-gradient(270deg, #5678a2 0%, #809cbf 100%);
        background: linear-gradient(270deg, #11568a 0%, #368ac9 100%);
      }

      .username,
      .password {
        position: relative;
        .rules {
          position: absolute;
          right: 7px;
          top: 50%;
          transform: translateY(-50%);
          color: red;
          transition: opacity 0.25s ease;
        }
        ::v-deep .ivu-input-type-password {
          font-size: 50px;
          .ivu-input-suffix {
            i {
              font-size: 20px !important;
              line-height: 40px !important;
              color: #003157 !important;
            }
          }
        }
      }
      .username {
        margin-bottom: 24px;
      }

      .error {
        margin-top: 24px;
        padding: 12px;
        border-radius: 4px;
        color: #856404;
        background: #fff3cd;
        transition: opacity 0.25s ease;
        text-align: center;
      }
    }
  }
}

.remember-pwd {
  margin-top: 24px;
}
</style>
